export default "__VITE_ASSET__DsdnNVje__";